import React from 'react';
import classNames from 'classnames';
import ModalControlButton from '../ModalControlButton';


import './LPSectionCard.scss';

const LPSectionCard = ( {parentClassName, sectionTitle, title, bgColor, footer, textColor, image, subHeading, content, id, onClose, viewport, online, isRtl} ) => {
  const baseClassName = 'pb-lpsection-card';

  const classes = {
    [baseClassName]: true,
    [parentClassName]: parentClassName
  };

  return (
    <div className={classNames(classes)} id={id}>
      <div className={`${baseClassName}__header`} style={{background: `${bgColor}`}}>
        {!viewport.medium && <span onClick={onClose}>
          <ModalControlButton parentClassName={isRtl ? `${baseClassName}__close--rtl ${baseClassName}__close` : `${baseClassName}__close`} icon="close" onClick={onClose} outsideWrapper={false} closeOutsideWrapper={false}/>
        </span>}
        

        <p className={`${baseClassName}__head`}>{sectionTitle}</p>
        <p className={`${baseClassName}__title`} style={{color: `${textColor}`}}>{title}</p>
        {online && <img className={isRtl ? `${baseClassName}__image ${baseClassName}__image--rtl` : `${baseClassName}__image`} src={image} alt={`${id}`} />}
      </div>
      {subHeading && <p className={`${baseClassName}__sub-header`}>{subHeading}</p>}
      <div className={`${baseClassName}__content`}>
        {content}
      </div>
      {!viewport.medium && footer}
    </div>
  );
}

export default LPSectionCard;



// WEBPACK FOOTER //
// ./src/components/LPSectionCard/LPSectionCard.jsx